import React from 'react';

import { FlexBox, Typography } from '@vp/swan';
import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';
import { PriceDisplay } from '@vp/component-library';

/**
 * Simple single line price summary with label.
 * @param {*} priceCents Price to be displayed
 */
export const DiscountSummary = ({
  fractionDigits,
  savedCents,
  currency,
  currencyLocale,
}) => {
  const [cartMessages] = useTranslations(['cartMessages']);

  return savedCents && savedCents > 0 ? (
    <FlexBox justifyContent="space-between" marginBottom={4} role="row">
      <div role="columnheader">
        <Typography
          fontWeight="bold"
          fontSize={1}
          component="label"
          className="swan-discount-price"
        >
          {cartMessages.youSaved}
        </Typography>
      </div>
      <div role="cell">
        <PriceDisplay
          fractionDigits={fractionDigits}
          centPrice={savedCents}
          currency={currency}
          fontWeight="bold"
          fontSize={2}
          locale={currencyLocale}
          discounted
        />
      </div>
    </FlexBox>
  ) : null;
};

DiscountSummary.propTypes = {
  fractionDigits: PropTypes.number.isRequired,
  savedCents: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  currencyLocale: PropTypes.string.isRequired,
};
